import styled from 'styled-components';

export const SteperContainer = styled.div`
  width: 547px;
  max-width: 100%;
`;

export const StepsContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 32px;
  flex-direction: column;
  align-items: center;
`;
